<template>
  <div
    class="i-light-box"
    @click="$emit('close')"
  >
    <div>
      <img
        class="close"
        :src="iconClose"
      />
    </div>

    <div
      class="wrap"
      @click.stop
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import iconClose from "@/assets/icons/icon-close-v2-white.svg"

// Emits
defineEmits(["close"])
</script>

<style lang="scss" scoped>
.i-light-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 80%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 5vh;

  .close {
    cursor: pointer;
    position: absolute;
    top: 3vh;
    right: 3vw;
    z-index: 10;
  }

  .wrap {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }
}
</style>
